export const CITY_CENTER_COORDINATES = {
  lat: 51.260197,
  lng: 4.402771,
};
